import { useState, type MouseEvent } from 'react';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useUser } from '../../contexts/UserContext';

interface ProfileMenuProps {
  onLogout: () => void;
}

/**
 * Avatar + logout dropdown, rendered in `HamburgerNavBar`'s `endContent` slot
 * (the same slot AdminPortal uses for its help-centre button).
 */
const ProfileMenu = ({ onLogout }: ProfileMenuProps) => {
  const { initials } = useUser();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  const handleLogout = () => {
    setAnchor(null);
    onLogout();
  };

  return (
    <>
      <IconButton
        aria-label='account of current user'
        aria-controls='profile-menu'
        aria-haspopup='true'
        onClick={(event: MouseEvent<HTMLButtonElement>) =>
          setAnchor(event.currentTarget)
        }
        color='primary'
      >
        <Avatar
          sx={{
            textTransform: 'uppercase',
            width: 36,
            height: 36,
            fontSize: '0.9rem',
          }}
        >
          {initials}
        </Avatar>
      </IconButton>

      <Menu
        id='profile-menu'
        anchorEl={anchor}
        keepMounted
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
      >
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
    </>
  );
};

export default ProfileMenu;
